import { render, staticRenderFns } from "./SellerTable.vue?vue&type=template&id=0b00a31c&scoped=true"
import script from "./SellerTable.vue?vue&type=script&lang=js"
export * from "./SellerTable.vue?vue&type=script&lang=js"
import style0 from "./SellerTable.vue?vue&type=style&index=0&id=0b00a31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b00a31c",
  null
  
)

export default component.exports